import { msg } from "components/schema/msg";
import { validationPatterns } from "constant/validationPatterns";
import * as Yup from "yup";

export const ApiKeySchema = Yup.object().shape({
  api_key: Yup.string()
    .matches(
      validationPatterns.api,
      msg("apiKeyPattern")
    )
    .required(msg("apiKeyRequired")),

  sales_point_id: Yup.string()
    .matches(
      validationPatterns.salesPointId,
      msg("salesPointIdPattern")
    )
    .required(msg("salesPointIdRequired")),
});
